import React, { useEffect } from 'react';

import './Xapine.scss';

import registerAnimations from './registerAnimations';

import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget';

/*** static images ***/
import sec1Leaf1 from '../../static/images/xapine/leaf-1.png';
import sec1Leaf2 from '../../static/images/xapine/leaf-2.png';
import sec1Leaf3 from '../../static/images/xapine/leaf-3.png';
import sec2Shoe1 from '../../static/images/xapine/shoe-1.png';
import sec2Shoe2 from '../../static/images/xapine/shoe-2.png';
import sec2Shoe3 from '../../static/images/xapine/shoe-3.png';
import sec2ImageBackground from '../../static/images/xapine/sec2-bg.png';
import sec3ShoeLayer1 from '../../static/images/xapine/shoe-layers-1.png';
import sec3ShoeLayer2 from '../../static/images/xapine/shoe-layers-2.png';
import sec3ShoeLayer3 from '../../static/images/xapine/shoe-layers-3.png';
import sec3ShoeLayer4 from '../../static/images/xapine/shoe-layers-4.png';
import staticSec7ShoeImage1 from '../../static/images/xapine/merino-shoe.png';
import staticSec7ShoeImage2 from '../../static/images/xapine/shoe-grip.png';
import staticSec7CircleImage from '../../static/images/xapine/circle.svg';
import staticSec8Image from '../../static/images/xapine/footbed.png';
import quotes from '../../static/images/xapine/qoute.png';
import staticSec9Image from '../../static/images/xapine/upsell.png';
import staticSec1Image from '../../static/images/xapine/featured-shoe.png';
import staticSec1ImageMobile from '../../static/images/xapine/featured-shoe-sm.png';
import staticSec4BackgroundImage from '../../static/images/xapine/sec4-bg.jpg';
import staticSec4BackgroundMobileImage from '../../static/images/xapine/sec4-bg-sm.jpg';
import staticSec5BackgroundImage from '../../static/images/xapine/sec5-bg.jpg';
import staticSec5BackgroundMobileImage from '../../static/images/xapine/sec5-bg-sm.jpg';
import staticSec6BackgroundImage from '../../static/images/xapine/sec6-bg.jpg';
import staticSec6BackgroundMobileImage from '../../static/images/xapine/sec6-bg-sm.jpg';
import staticSec7BackgroundImage from '../../static/images/xapine/sec7-bg.jpg';
import staticSec7BackgroundMobileImage from '../../static/images/xapine/sec7-bg-sm.jpg';
import staticSec8BackgroundImage from '../../static/images/xapine/sec8-bg.jpg';
import staticSec8BackgroundMobileImage from '../../static/images/xapine/sec8-bg-sm.jpg';

const LandingPageXapine = ({
  sec1Heading,
  sec1Button1Text,
  sec1Button1Url,
  sec1Button2Text,
  sec1Button2Url,
  sec1Image,
  sec1ImageMobile,
  sec1Subtitle,
  sec1part2Title,
  sec1part2Subtitle,
  sec1part2Fact1,
  sec1part2Fact2,
  sec1part2Fact3,
  sec2Title,
  sec3Title,
  sec3FactLabel1,
  sec3FactValue1,
  sec3FactLabel2,
  sec3FactValue2,
  sec3FactLabel3,
  sec3FactValue3,
  sec3FactLabel4,
  sec3FactValue4,
  sec3FactLabel5,
  sec3FactValue5,
  sec4Title,
  sec4Content,
  sec4Button1Text,
  sec4Button1Url,
  sec4Button2Text,
  sec4Button2Url,
  sec5Title,
  sec5Content,
  sec6Title,
  sec6Content,
  sec7Title1,
  sec7Content1,
  sec7Title2,
  sec7Content2,
  sec7Button1Text,
  sec7Button1Url,
  sec7Button2Text,
  sec7Button2Url,
  sec7shoeImage1,
  sec7ShoeImage2,
  sec7CircleImage,
  sec8Title,
  sec8content,
  sec8ButtonText,
  sec8ButtonUrl,
  sec8Image,
  sec9Button1Text,
  sec9Button1Url,
  sec9Button2Text,
  sec9Button2Url,
  sec9Content,
  sec9Image,
  sec4BackgroundImage,
  sec4BackgroundMobileImage,
  sec5BackgroundImage,
  sec5BackgroundMobileImage,
  sec6BackgroundImage,
  sec6BackgroundMobileImage,
  sec7BackgroundImage,
  sec7BackgroundMobileImage,
  sec8BackgroundImage,
  sec8BackgroundMobileImage,
}) => {
  useEffect(() => {
    if (window) {
      const { $ } = window;
      registerAnimations($);
    }
  }, []);

  return (
    <div className="landingpage-xapine">
      <section className="banner pb-0">
        <div className="container">
          <article className="content clearfix text-md-left font-weight-light">{sec1Heading}</article>
          <p className="quality">{sec1Subtitle}</p>
        </div>
        <div className="cta">
          <div className="container">
            <p className="  mb-0 text-center text-md-left">
              <a href={sec1Button1Url} className="btn btn-outline-light  mb-1 mr-2 btn-size-md_0">
                {sec1Button1Text}
              </a>
              <a href={sec1Button2Url} className="btn btn-outline-light mb-1 ml-2 btn-size-md_0">
                {sec1Button2Text}
              </a>
            </p>
          </div>
        </div>
        <div className="container sec2_part_1 features">
          <h2 className="text-center font-weight-bold">
            <strong>{sec1part2Title}</strong> <small className="font-weight-bold">{sec1part2Subtitle}</small>
          </h2>
          <ul>
            <li>
              <span>{sec1part2Fact1}</span>
            </li>
            <li>
              <span>{sec1part2Fact2}</span>
            </li>
            <li>
              <span>{sec1part2Fact3}</span>
            </li>
          </ul>
        </div>
        <figure className="featured-shoe-cont">
          <img src={sec1ImageMobile} className="featured-shoe-sm featured-shoe d-block d-md-none col-12 px-0" alt="" />
          <img src={sec1Image} className="featured-shoe d-none d-md-block col-12 px-0" alt="" />
        </figure>
        <img src={sec1Leaf1} alt="" className="leaf leaf-1 d-none d-lg-block hide animated slow" />
        <img src={sec1Leaf2} alt="" className="leaf leaf-2 hide animated delay-2 slow" />
        <img src={sec1Leaf3} alt="" className="leaf leaf-3 hide animated slow long" />
      </section>
      <section className="sec sec2 position-relative">
        <div className="container position-relative z-index-2">
          <div className="row ">
            <article className="content  col-12 text-center">
              <h2 className="fill-gradient-v2 font-weight-bold pb-lg-5 mb-xl-5 ">{sec2Title}</h2>
              <div className="shoes-color mt-4 pt-xl-5">
                <div className="slide">
                  <img src={sec2Shoe1} alt="" />
                </div>
                <div className="slide">
                  <img src={sec2Shoe2} alt="" />
                </div>
                <div className="slide">
                  <img src={sec2Shoe3} alt="" />
                </div>
              </div>
            </article>
          </div>
        </div>
        <img src={sec2ImageBackground} className="sec2-bg hide animated" alt="" />
      </section>
      <section className="sec sec3 pb-xl-5 d-flex">
        <div className="container  d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12  col-md-5 col-xl-6 mb-lg-0 features2 align-self-center">
              <h2 className="mb-4 fill-gradient">{sec3Title}</h2>
              <ul className="row">
                <li className="col-12">
                  <strong className="fill-gradient">{sec3FactLabel1}</strong>
                  {sec3FactValue1}
                </li>
                <li className="col-6">
                  <strong className="fill-gradient">{sec3FactLabel2}</strong>
                  {sec3FactValue2}
                </li>
                <li className="col-6">
                  <strong className="fill-gradient">{sec3FactLabel3}</strong>
                  {sec3FactValue3}
                </li>
                <li className="col-6">
                  <strong className="fill-gradient">{sec3FactLabel4}</strong>
                  {sec3FactValue4}
                </li>
                <li className="col-6">
                  <strong className="fill-gradient">{sec3FactLabel5}</strong>
                  {sec3FactValue5}
                </li>
              </ul>
            </article>
            <div className="col-12  col-md-7 col-xl-6  mb-5 ">
              <div id="slipper-animation">
                <div id="animationWrapper" className="clearfix">
                  <div id="slipper-animation-container" className="float-lg-right">
                    <figure id="AnimationContainer" className="animation-container">
                      <picture id="layer-top">
                        <source srcSet={sec3ShoeLayer1} />
                        <img src={sec3ShoeLayer1} alt="" id="layer-top-img" />
                      </picture>
                      <picture id="layer-inside">
                        <source srcSet={sec3ShoeLayer2} />
                        <img src={sec3ShoeLayer2} alt="" id="layer-inside-img" />
                      </picture>
                      <picture id="layer-bottom">
                        <source srcSet={sec3ShoeLayer3} />
                        <img src={sec3ShoeLayer3} alt="" id="layer-bottom-img" />
                      </picture>
                      <picture id="layer-base">
                        <source srcSet={sec3ShoeLayer4} />
                        <img src={sec3ShoeLayer4} alt="" id="layer-insole-img" />
                      </picture>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>
        {`
        .sec4 {
          background-image: url(${sec4BackgroundMobileImage});
        }

        @media (min-width: 768px) {
          .sec4 {
            background-image: url(${sec4BackgroundImage});
          }
        }
      `}
      </style>

      <section className="sec sec4 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row flex-grow-1">
            <article className="content col-12 col-sm- col-md-7 col-lg-6 col-xl-5 ml-auto align-self-center">
              <h2>{sec4Title}</h2>
              <div className="pr-xl-4">
                <p className="pr-xl-5 mr-xl-5 font-weight-light">{sec4Content}</p>
              </div>
              <p className="pt-4  mb-0">
                <a href={sec4Button1Url} className="btn btn-outline-light  mb-1 mr-2 btn-size-md_0">
                  {sec4Button1Text}
                </a>
                <a href={sec4Button2Url} className="btn btn-outline-light mb-1 ml-2 btn-size-md_0">
                  {sec4Button2Text}
                </a>
              </p>
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
        .sec5 {
          background-image: url(${sec5BackgroundMobileImage});
        }

        @media (min-width: 768px) {
          .sec5 {
            background-image: url(${sec5BackgroundImage});
          }
        }
      `}
      </style>

      <section className="sec sec5 d-flex">
        <div className="container d-flex flex-grow-1">
          <div className="row  flex-grow-1">
            <article className="content col-12 col-md-9 col-lg-10 col-xl-9 mx-auto align-self-end">
              <div className="row">
                <h2 className="fill-gradient-v2 col-12 col-lg-4">{sec5Title}</h2>
                <p className=" col-12 col-lg-7">{sec5Content}</p>
              </div>
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
        .sec6 {
          background-image: url(${sec6BackgroundMobileImage});
        }

        @media (min-width: 768px) {
          .sec6 {
            background-image: url(${sec6BackgroundImage});
          }
        }
      `}
      </style>

      <section className="sec sec6  bg-dark d-flex position-relative">
        <div className="container d-flex flex-grow-1 position-static ">
          <div className="row flex-grow-1">
            <article className="content-2 col-9 col-md-6 col-lg-6 col-xl-5 pt-lg-4 mr-md-auto align-self-start">
              <h2>{sec6Title}</h2>
              <p className="mr-xl-4">{sec6Content}</p>
            </article>
          </div>
        </div>
      </section>

      <style>
        {`
        .sec7 {
          background-image: url(${sec7BackgroundMobileImage});
        }

        @media (min-width: 768px) {
          .sec7 {
            background-image: url(${sec7BackgroundImage});
          }
        }
      `}
      </style>

      <section className="sec sec7   position-relative">
        <div className="container d-flex flex-grow-1 position-static sec-tempareture">
          <div className="row flex-grow-1">
            <figure className="col-12 col-md-7  col-lg-6 align-self-center position-static order-md-1">
              <p className="hide animated circle-cont">
                <img src={sec7CircleImage} alt="" className="d-md-block circle-img " />
                <span className="merino-shoe">
                  <img src={sec7shoeImage1} alt="" className="d-md-block merino-shoe-img hide animated  delay-1" />
                </span>
              </p>
            </figure>
            <article className="content-2 col-12 col-md-5 col-lg-6 col-xl-5 pt-lg-4 mb-lg-5 ml-auto align-self-center order-md-2 mb-5">
              <h2 className="fill-gradient">
                <i className="icon4 d-none d-md-block" /> {sec7Title1}
              </h2>
              <p className="mr-xl-4">{sec7Content1}</p>
              <p className="pt-4  mb-0 d-none d-lg-block">
                <a href={sec7Button1Url} className="btn btn-outline-dark  mb-1 mr-2 btn-size-md_0">
                  {sec7Button1Text}
                </a>
                <a href={sec7Button2Url} className="btn btn-outline-dark mb-1 ml-2 btn-size-md_0">
                  {sec7Button2Text}
                </a>
              </p>
            </article>
          </div>
        </div>
        <div className="container d-flex flex-grow-1 position-static sec-stablity">
          <div className="row flex-grow-1">
            <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5 ml-auto align-self-center text-right text-md-left">
              <h2 className="has-icon icon-4">{sec7Title2}</h2>
              <p className="mr-xl-4">{sec7Content2}</p>
            </article>
            <figure className="col-6 ml-auto col-md-4 col-xl-5  align-self-center position-static ">
              <p className="hide0 animated fadeInRight">
                <img src={sec7ShoeImage2} alt="" className="d-md-block shoe-grip-img hide animated" />
              </p>
            </figure>
          </div>
        </div>
      </section>

      <style>
        {`
        .sec8 {
          background-image: url(${sec8BackgroundMobileImage});
        }

        @media (min-width: 768px) {
          .sec8 {
            background-image: url(${sec8BackgroundImage});
          }
        }
      `}
      </style>

      <section className="sec sec8 footbed  d-flex position-relative">
        <div className="container d-flex flex-grow-1 position-static ">
          <div className="row flex-grow-1">
            <article className="content-2 col-12 col-md-6 col-lg-6 col-xl-5 pt-lg-4 ml-md-auto align-self-center order-md-2">
              <h2 className="fill-gradient">{sec8Title}</h2>
              <p className="mr-xl-4">{sec8content}</p>
              <p className="pt-4  mb-0">
                <a href={sec8ButtonUrl} className="btn btn-outline-dark mb-1 ml-2 btn-size-md_0">
                  {sec8ButtonText}
                </a>
              </p>
            </article>
            <figure className="col-12 col-md-6  align-self-center position-static order-md-1">
              <p className="hide animated fadeInLeft">
                <img src={sec8Image} alt="" className="d-md-block footbed-img hide animated" />
              </p>
            </figure>
          </div>
        </div>
      </section>
      <section className="sec sec10 py-5 testimonials">
        <div className="container">
          <p className="text-center qoute pb-4">
            <img src={quotes} alt="" />
          </p>
        </div>
        <div className="trustBox-widget py-4 py-lg-5 mb-5">
          <div className="container">
            <TrustpilotWidget />
          </div>
        </div>
        <div className="testimonials-products">
          <div className="container">
            <div className="row">
              <figure className="d-none d-md-block col-12 col-md-5">
                <p>
                  <img src={sec9Image} alt="" />
                </p>
              </figure>
              <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                <h3>{sec9Content}</h3>
                <figure className="d-md-none">
                  <img src={sec9Image} alt="" />
                </figure>
                <p className="btn-cont mt-4 pt-1 text-center text-md-left">
                  <a href={sec9Button1Url} className="btn btn-dark  d-md-inline-block mb-3 mr-1">
                    {sec9Button1Text}
                  </a>
                  <a href={sec9Button2Url} className="btn btn-dark  d-md-inline-block mb-3 ml-sm-3">
                    {sec9Button2Text}
                  </a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

LandingPageXapine.defaultProps = {
  sec1Heading: (
    <h1>
      <strong>
        WOOL <br /> CROSS X <br /> ALPINE
      </strong>
    </h1>
  ),
  sec1Subtitle: 'The super-comfortable hiking shoe with Merino Wool',
  sec1Button1Text: 'WOMEN',
  sec1Button1Url: '#',
  sec1Button2Text: 'MEN',
  sec1Button2Url: '#',
  sec1Image: staticSec1Image,
  sec1ImageMobile: staticSec1ImageMobile,
  sec1part2Title: 'THE GIESSWEIN WOOL',
  sec1part2Subtitle: 'CROSS X ALPINE AT A GLANCE',
  sec1part2Fact1: (
    <>
      <strong>100%</strong> <em>Waterproof </em>
    </>
  ),
  sec1part2Fact2: (
    <>
      <strong>100%</strong>
      <em>
        Merino wool <br /> inner lining
      </em>
    </>
  ),
  sec1part2Fact3: (
    <>
      <strong>
        Stability <br /> and support
      </strong>
      <em>Padded, half-height shaft for stability and support</em>
    </>
  ),
  sec2Title: 'COLOR RANGE',
  sec3Title: (
    <>
      Discover <br /> Merino <br /> wool layers <br /> of comfort
    </>
  ),
  sec3FactLabel1: 'WATERPROOF',
  sec3FactValue1: '100% Waterproof',
  sec3FactLabel2: '100%',
  sec3FactValue2: (
    <>
      3D Stretch <br /> Merino wool
    </>
  ),
  sec3FactLabel3: '100%',
  sec3FactValue3: (
    <>
      Merino wool <br /> inner lining
    </>
  ),
  sec3FactLabel4: (
    <>
      Merino <br /> Wool
    </>
  ),
  sec3FactValue4: (
    <>
      Performance <br /> footbed
    </>
  ),
  sec3FactLabel5: 'Micro-Grip',
  sec3FactValue5: 'Sole technology',
  sec4Title: 'LIGHT, COMFORTABLE AND SUPPORTIVE',
  sec4Content:
    'In the past, hiking shoes were often bulky and felt as heavy as lead - but not our Wool Cross X Alpine, which weigh in at just 860 grams. Thanks to our unique Giesswein 3D KnitTechnology, the shoes’ flexible material molds to your foot - without sacrificing stability.',
  sec4Button1Text: 'WOMEN',
  sec4Button1Url: '#',
  sec4Button2Text: 'MEN',
  sec4Button2Url: '#',
  sec5Title: 'ADIOS, PRESSURE POINTS!',
  sec5Content:
    'In the past, hiking shoes were often bulky and felt as heavy as lead - but not our Wool Cross X Alpine, which weigh in at just 860 grams. Thanks to our unique Giesswein 3D KnitTechnology, the shoes’ flexible material molds to your foot - without sacrificing stability.',
  sec6Title: 'DRY FEET - NO MATTER THE WEATHER',
  sec6Content:
    'Our Wool Cross X Alpine is made out of water-resistant material, which is created out of renewable raw resources. Combined with a Merino wool inner lining, your feet will stay comfortably warm and dry — even in rain or snow',
  sec7Title1: 'MERINO WOOL. TEMPERATURE REGULATING.',
  sec7Content1:
    'When hiking in the summer heat, the Wool Cross X Alpine’s composition of Merino wool ensures that moisture will be wicked away from your feet, and slowly transported away from the skin. The perfect hiking shoe for all temperatures.',
  sec7Title2: 'MAXIMUM STABILITY. MAXIMUM GRIP.',
  sec7Content2:
    'The special Micro-Grip Sole featured on our Wool Cross X Alpine offers stability and grip on all types of terrain.',
  sec7Button1Text: 'WOMEN',
  sec7Button1Url: '#',
  sec7Button2Text: 'MEN',
  sec7Button2Url: '#',
  sec7shoeImage1: staticSec7ShoeImage1,
  sec7ShoeImage2: staticSec7ShoeImage2,
  sec7CircleImage: staticSec7CircleImage,
  sec8Title: 'INTERCHANGEABLE FOOTBED.',
  sec8content:
    'The special Micro-Grip Sole featured on our Wool Cross X Alpine offers stability and grip on all types of terrain.',
  sec8ButtonText: 'BUY FOOTBED',
  sec8ButtonUrl: '#',
  sec8Image: staticSec8Image,
  sec9Button1Text: 'WOMEN',
  sec9Button1Url: '#',
  sec9Button2Text: 'MEN',
  sec9Button2Url: '#',
  sec9Content: (
    <>
      <strong>These Clients bought this shoe,</strong> <br className="d-none d-md-block" /> Maybe try this one too
    </>
  ),
  sec9Image: staticSec9Image,
  sec4BackgroundImage: staticSec4BackgroundImage,
  sec4BackgroundMobileImage: staticSec4BackgroundMobileImage,
  sec5BackgroundImage: staticSec5BackgroundImage,
  sec5BackgroundMobileImage: staticSec5BackgroundMobileImage,
  sec6BackgroundImage: staticSec6BackgroundImage,
  sec6BackgroundMobileImage: staticSec6BackgroundMobileImage,
  sec7BackgroundImage: staticSec7BackgroundImage,
  sec7BackgroundMobileImage: staticSec7BackgroundMobileImage,
  sec8BackgroundImage: staticSec8BackgroundImage,
  sec8BackgroundMobileImage: staticSec8BackgroundMobileImage,
};

export default LandingPageXapine;
